<script setup>
import { computed } from 'vue';
import { getTaskDueDate } from 'dashboard/helper/taskRecurrence';

const props = defineProps({
  results: { type: Array, default: () => [] },
});

const emit = defineEmits(['select']);

const formatDueDate = task => {
  const dueDate = getTaskDueDate(task);
  const options = task.allDay
    ? { day: '2-digit', month: 'short', year: 'numeric' }
    : {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
  return new Intl.DateTimeFormat('pt-BR', options).format(dueDate);
};

const items = computed(() =>
  props.results.map(task => ({ task, label: formatDueDate(task) }))
);
</script>

<template>
  <div
    class="absolute z-50 w-full mt-1 border rounded-md shadow-lg bg-n-solid-1 border-n-strong"
  >
    <ul class="py-1 mb-0 overflow-y-auto max-h-60" role="listbox">
      <li
        v-for="{ task, label } in items"
        :key="task.id"
        class="flex flex-col gap-0.5 px-3 py-2 text-sm transition-colors duration-150 cursor-pointer hover:bg-n-alpha-2"
        role="option"
        @click="emit('select', task)"
      >
        <span class="font-medium truncate text-n-slate-12">{{
          task.title
        }}</span>
        <span class="text-xs text-n-slate-11">{{ label }}</span>
      </li>
    </ul>
  </div>
</template>
